import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { styles } from "./styles";

const AUDIENCES = [
  {
    title: "For Organizations",
    bullets: [
      "One dashboard to manage courses, instructors, and enrollment.",
      "Payments collected and instructor payouts handled end to end.",
      "Your programs under your brand, hosted, published, and maintained for you.",
    ],
  },
  {
    title: "For Instructors",
    bullets: [
      "Guided onboarding and a dashboard built around teaching.",
      "Scheduling, messaging, and file sharing in one place.",
      "Walk into class with one click. Video conferencing is built in.",
    ],
  },
  {
    title: "For Students",
    bullets: [
      "Simple onboarding: enroll and join classes from anywhere.",
      "One dashboard for schedules, live classes, and materials.",
      "Live, interactive group classes, not recorded lectures.",
    ],
  },
];

const AudienceSection = () => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg">
        <Typography component="h2" sx={styles.sectionTitle}>
          One platform, three great experiences
        </Typography>
        <Grid container spacing={3} mt={4}>
          {AUDIENCES.map(({ title, bullets }) => (
            <Grid key={title} xs={12} md={4}>
              <Box sx={styles.audienceCard}>
                <Typography sx={styles.audienceTitle}>{title}</Typography>
                <Stack spacing={2}>
                  {bullets.map((bullet) => (
                    <Stack
                      key={bullet}
                      direction="row"
                      spacing={1.5}
                      alignItems="flex-start"
                    >
                      <CheckCircleOutlineIcon
                        color="primary"
                        fontSize="small"
                        sx={{ mt: "2px" }}
                      />
                      <Typography sx={styles.audienceBullet}>
                        {bullet}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default AudienceSection;
